import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface CounterState {
  count: number
}

interface CounterActions {
  increment: () => void
  decrement: () => void
  reset: () => void
  setCount: (value: number) => void
}

type CounterStore = CounterState & CounterActions

const STORE_NAME = 'counter-storage' as const

export const useCounterStore = create<CounterStore>()(
  devtools(
    persist(
      (set): CounterStore => ({
        count: 0,
        increment: (): void => {
          set(
            (state: CounterStore): Partial<CounterStore> => ({
              count: state.count + 1,
            }),
            false,
            'increment'
          )
        },
        decrement: (): void => {
          set(
            (state: CounterStore): Partial<CounterStore> => ({
              count: state.count - 1,
            }),
            false,
            'decrement'
          )
        },
        reset: (): void => {
          set({ count: 0 }, false, 'reset')
        },
        setCount: (value: number): void => {
          set({ count: value }, false, 'setCount')
        },
      }),
      {
        name: STORE_NAME,
      }
    ),
    {
      name: 'CounterStore',
      enabled: import.meta.env.DEV,
    }
  )
)

export type { CounterState, CounterActions, CounterStore }
